/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import DOMPurify from "dompurify";
import "swiper/css";
import "swiper/css/pagination";

import { UseLangContext } from "../../contexts/Lang";
import { Service as ServiceType } from "../../@types/lang";

import IcArrowRight from "../../assets/images/arrow-right-slider.svg";
import IcArrowLeft from "../../assets/images/arrow-left-slider.svg";

type Props = {};

const Service = (props: Props) => {
  const [selectedImg, setSelectedImg] = useState(null);

  const handleImageClick = (e) => {
    // Cek apakah yang diklik adalah elemen IMG
    if (e.target.tagName === "IMG") {
      setSelectedImg(e.target.src);
    }
  };
  const { id } = useParams();
  const {
    lang,
    getExistService,
    t: { services, global },
  } = UseLangContext();
  const [service, setService] = useState<any>({});
  const navigate = useNavigate();
  const [images, setImages] = useState<any>(null);

  useEffect(() => {
    const serviceExist = getExistService(id);
    document.title = `Omega Solusindo Bersama | ${serviceExist.title}`;
    if (!serviceExist.overview) {
      navigate("/maintaince");
    }
    setService(serviceExist);
    setImages(serviceExist?.imageProductService);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, id]);
  const hasMultipleImages = Array.isArray(images) && images.length > 1;

  return (
    <div className="px-6 lg:px-20 pt-10">
      {/* Navigation */}
      <div className="inline-flex gap-4 md:gap-0 justify-center items-center w-full px-6 lg:px-20">
        <div className="flex space-x-4 items-center justify-center">
          <Link to="/" className="text-[#A0A0A0]">
            Home
          </Link>
          <span>&gt;</span>
          <div className="flex space-x-2 items-center text-[14px] lg:text-[16px]">
            <p className="text-[#A0A0A0]">Service</p>
            <p className="text-[#A0A0A0]">/</p>
            <p className="font-semibold border-b border-solid border-black">
              {service.title}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-4 md:mt-10 text-center flex flex-col gap-8">
        <p className="text-[30px] font-semibold text-[#3B3B3B]">
          {global.titleInServiceDetail}
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-8 gap-4 justify-center items-center">
          <div className="bg-[#81B465] h-1 w-full hidden lg:block order-first"></div>
          {services?.map((serviceItem: ServiceType, index: number) => (
            <Link
              key={index}
              to={`/service/${serviceItem?.title?.toLowerCase().replace(/\s+/g, "-")}`}
              className={`col-span-2 border border-solid border-[#A0A0A0] p-3 flex gap-2 items-center rounded-lg w-full cursor-pointer hover:bg-[#504E48] group transition-all duration-300 ease-in-out min-h-[90px] ${serviceItem.id === service.id ? "bg-[#504E48] pointer-events-none" : "bg-white"}`}
            >
              <div className="group-hover:bg-white rounded-full p-1">
                <div
                  dangerouslySetInnerHTML={{ __html: serviceItem.iconUrl }}
                />
              </div>
              <p
                className={`text-[18px] font-medium group-hover:text-white ${serviceItem.id === service.id ? "text-white" : "text-[#3B3B3B]"}`}
              >
                {serviceItem.title}
              </p>
            </Link>
          ))}
          <div className="bg-[#81B465] h-1 w-full hidden lg:block order-last"></div>
        </div>
      </div>

      {/* Image slider */}
      {images && (
        <div className="mb-[50px] pt-8 flex items-center justify-center gap-x-2 overflow-hidden relative">
          <div className="swiper-button-back w-[50px] h-[50px] cursor-pointer active:bg-none absolute left-4 z-10 top-[50%] rounded-full bg-white/20 flex items-center justify-center hover:bg-white/100 transition-all duration-300 eease-in-out active:ring-0 focus:ring-0">
            <img src={IcArrowLeft} alt="arrow-left" />
          </div>

          <Swiper
            key={`${id}-${images?.length ?? 0}`}
            modules={[Autoplay, Pagination, Navigation]}
            pagination={{
              clickable: true,
            }}
            spaceBetween={20}
            loop={hasMultipleImages}
            speed={1200}
            autoplay={
              hasMultipleImages
                ? {
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                    waitForTransition: true,
                  }
                : false
            }
            observer={true}
            observeParents={true}
            onSwiper={(swiper) => {
              if (
                hasMultipleImages &&
                swiper?.autoplay &&
                !swiper.autoplay.running
              ) {
                swiper.autoplay.start();
              }
            }}
            navigation={{
              prevEl: ".swiper-button-back",
              nextEl: ".swiper-button-go",
            }}
            className="mySwiper px-0 md:px-6"
          >
            {images.map((image, idx) => (
              <SwiperSlide key={idx}>
                <div className="w-full aspect-[16/9] rounded-[20px] bg-[#F5F5F5] overflow-hidden">
                  <img
                    src={image}
                    alt={`images-${idx}`}
                    className="w-full h-full object-cover object-center"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="swiper-button-go w-[50px] h-[50px] cursor-pointer absolute right-4 text-right z-10 top-[50%] bg-white/20 flex items-center justify-center rounded-full hover:bg-white/100 transition-all duration-300 eease-in-out active:ring-0 focus:ring-0">
            <img src={IcArrowRight} alt="arrow-right" />
          </div>
        </div>
      )}

      <div
        onClick={handleImageClick}
        className="text-sm md:text-[16px] text-justify font-normal leading-[35px] text-[#444] mb-12"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(service.overview),
        }}
      ></div>

      {selectedImg && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
          onClick={() => setSelectedImg(null)}
        >
          <div className="mx-4 max-h-[90vh] w-full max-w-4xl overflow-y-auto rounded-lg bg-white p-6 relative">
            <button
              className=" text-black text-lg inline-flex justify-end hover:text-[#3e3e3e] w-full "
              onClick={() => setSelectedImg(null)}
            >
              &times;
            </button>
            <div className="w-[400px] h-[400px] mx-auto">
              <img
                src={selectedImg}
                alt="Preview"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Service;
